import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fixes the default icon issue in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const ContactData = () => {
  const contactDetails = {
    emails: ["contact@tabbibi.com", "doc.support@tabbibi.com"],
    phoneNumbers: ["+213 671 75 45 91"],
    address: "Université badji Mokhtar, sidi achour, Annaba, Algeria",
    addressAr: "جامعة باجي مختار - عنابة (القطب الجامعي سيدي عاشور)",
  };

  const position = [36.86918987832175, 7.717800029132303];

  return (
    <div className="w-full px-4 py-8">
      <div className="contact-map-div">
        {/* Contact Details */}
        <div className="sm:w-[100%] w-1/2 block gap-4 ">
          <h2 className="text-2xl font-bold">Contact</h2>
          <div className="mb-5">
            <h3 className="font-semibold">Emails:</h3>
            <ul>
              {contactDetails.emails.map((email, index) => (
                <li key={index}>{email}</li>
              ))}
            </ul>
          </div>
          <div className="mb-5">
            <h3 className="font-semibold">Phone Numbers:</h3>
            <ul>
              {contactDetails.phoneNumbers.map((phone, index) => (
                <li key={index}>
                  {phone}{" "}
                  <button
                    onClick={() => (window.location.href = `tel:${phone}`)}
                    className="ml-2 text-blue-500 underline"
                  >
                    Appeler
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="mb-5">
            <h3 className="font-semibold">Address:</h3>
            <p>
              {contactDetails.address}{" "}
              <button
                onClick={() =>
                  window.open(
                    "https://maps.app.goo.gl/8TVcfQmoKzBacgKN6",
                    "_blank"
                  )
                }
                className="ml-2 text-blue-500 underline"
              >
                Afficher sur le Maps
              </button>
            </p>
            <p className="mt-3 sm:text-right">
              {contactDetails.addressAr}{" "}
              <button
                onClick={() =>
                  window.open(
                    "https://maps.app.goo.gl/8TVcfQmoKzBacgKN6",
                    "_blank"
                  )
                }
                className="ml-2 text-blue-500 underline"
              >
                عرض على الخريطة
              </button>
            </p>
          </div>
        </div>

        {/* Map */}
        <div className="sm:w-[100%] w-1/2 border border-mainColor rounded-2xl">
          <MapContainer
            center={position}
            zoom={13}
            style={{ height: "400px", width: "100%", borderRadius: "16px" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={position}>
              <Popup>Tabbibi</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default ContactData;
